// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"EmailSummary--keyboard_navigation_jump--2s0NZ","loading":"EmailSummary--loading--HcObL","label":"EmailSummary--label--2t4d5","emailSvg":"EmailSummary--emailSvg--kAYRu","statusSuccess":"EmailSummary--statusSuccess--1Y4Hu","statusError":"EmailSummary--statusError--tRJk3","wrapper":"EmailSummary--wrapper--YkMkj","secondaryButton":"EmailSummary--secondaryButton--1u7GD","shake":"EmailSummary--shake--2vhrC"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/EmailSummary/EmailSummary.css
// module id = 1019
// module chunks = 0